module.exports = __webpack_public_path__ + "img/home_twelve.554015e3.png";